import { Box, Button, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { get } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';
import { CheckCircle } from '@mui/icons-material';
import { RESERVATION_STEP, usePageViewEvent } from '../hooks/useGTMEvent';
import { CookieStorage } from 'aws-amplify/utils';
import { executeGet } from '@/client/rest';

const RELOAD_INTERVAL = 2000;

export const ReservationDone = (props: any) => {
  const [isInterview, setInterview] = useState<boolean>();
  const navigate = useNavigate();

  const facilityId = props.currentState.facilityId || '';
  const redirectUrl = `/patient/reservation?fid=${facilityId}`;

  const getIsInterView = async () => {
    const session = await fetchAuthSession();
    const cognitoId = session.userSub;
    const data = (await executeGet({
      apiName: 'medirecoWebApi',
      path: '/get-is-interview-identify',
      options: {
        queryParams: {
          id: cognitoId!
        }
      }
    })) as any;
    console.log(data.isInterview);
    if (data.isInterview) {
      setInterview(true);
    } else {
      setInterview(false);
      const timer = setTimeout(() => {
        window.location.href = redirectUrl;
      }, RELOAD_INTERVAL);
      return () => clearTimeout(timer);
    }
  };

  const nextContractPage = () => {
    // mynumber関連の施設IDの仕様が未確定のため、現時点ではmynumberに関連する施設IDのみを
    // セッションストレージとcookieに保存する仕様としている
    // mynumber周り以外は、sessionStorageは廃止しているため、この処理は暫定的なもの
    sessionStorage.setItem('facility_id', facilityId);
    const cookie = new CookieStorage();
    cookie.setItem('facility_id', facilityId);
    navigate('/patient/agreement');
  };

  useEffect(() => {
    getIsInterView();
  }, []);

  usePageViewEvent({ pageTitle: RESERVATION_STEP.Complete, facilityId });

  if (isInterview === false) {
    return (
      <Grid container direction={'row'} spacing={2}>
        <Grid item xs={0} md={3} sm={2} />
        <Grid item xs={12} md={6} sm={8}>
          <Grid container direction={'column'} spacing={2}>
            <Grid item xs={12} mt={8} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
              <CheckCircle sx={{ color: '#3582BC', fontSize: 200 }} />
            </Grid>
            <Grid item xs={12} sx={{ textAlign: 'center', maxWidth: '100% !important' }}>
              <Typography mb={2} pt={2} fontSize={'16px'} className="font-bold">
                ご予約を承りました
              </Typography>
              <Typography mb={2} fontSize={'14px'}>
                こちらのページは自動的に切り替わります
                <br />
                自動的に切り替わらない場合は
                <br />
                <span
                  onClick={() => (window.location.href = redirectUrl)}
                  style={{ cursor: 'pointer', color: '#3582BC', textDecoration: 'underline' }}
                >
                  こちら
                </span>
                クリックしてください
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  } else if (isInterview === true) {
    return (
      <Grid container direction={'row'} justifyContent="center">
        <Grid item xs={1} md={3} sm={2} />
        <Grid item xs={10} md={6} sm={8}>
          <Typography className="font-bold" textAlign={'center'} marginTop={5}>
            ご予約が完了しました。
          </Typography>
          <Typography textAlign={'center'} marginTop={3}>
            ご予約ありがとうございました
            <br />
            次へお進みください
          </Typography>
          <Box display="flex" justifyContent="space-between">
            <Button variant="contained" fullWidth onClick={nextContractPage} sx={{ mt: 3, mb: 2 }}>
              <Typography className="text-white" sx={{ my: 0.5 }}>
                次へ進む
              </Typography>
            </Button>
          </Box>
        </Grid>
        <Grid item xs={1} md={3} sm={2} />
      </Grid>
    );
  }
};
